export default {
  options: {
    violationTypeList: [],
    violationLevelList: [],
  },
}
